import { render, staticRenderFns, recyclableRender, components } from "./shop-mine.vue?vue&type=template&id=cdb1bf48&scoped=true&"
var renderjs
import script from "./shop-mine.vue?vue&type=script&lang=js&"
export * from "./shop-mine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb1bf48",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop-mine/shop-mine.vue"
export default component.exports